
<p-toast key="global-toast"></p-toast>
<qa-navigation-bar-header></qa-navigation-bar-header>

<div style="min-height: 90vh">
  <router-outlet></router-outlet>
</div>

<qa-navigation-footer></qa-navigation-footer>

